// extracted by mini-css-extract-plugin
module.exports = {"button-default":"RSIconButton_button-default__cw462"};